const domainName = 'https://api.syrplus.io';
//const domainName = 'http://localhost:8000';

export default domainName;
